import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/16/solid";
import { Children } from "react";

import { HStack } from "@/components/layout";
import { DEFAULT_ITEMS_PER_PAGE } from "@/config";
import { useSearchParams } from "@/hooks";
import Paginatable from "@/modules/paginatable";
import PageButton from "./page-button";
import PaginationButton from "./pagination-button";

export default function Pagination({ totalItems }) {
  const { setParams, getParam } = useSearchParams();

  const currentPage = Number(getParam("page")) || 1;
  const perPage = Number(getParam("perPage")) || DEFAULT_ITEMS_PER_PAGE;

  const paginatable = new Paginatable({
    currentPage,
    totalItems,
    perPage,
  });

  const handleChangePage = (page) => setParams({ page });

  if (paginatable.hasOnlyOnePage) return <></>;

  return (
    <HStack className="items-center justify-between bg-white">
      <PaginationButton
        page={paginatable.prevPage}
        onClick={handleChangePage}
        disabled={paginatable.isFirstPage}
      >
        <ArrowLeftIcon className="w-4 scale-x-125 transform" />
        Previous page
      </PaginationButton>

      <HStack className="items-center">
        {Children.toArray(
          paginatable.list.map((page) => (
            <PageButton
              onClick={handleChangePage}
              currentPage={paginatable.currentPage}
              page={page}
            />
          )),
        )}
      </HStack>

      <PaginationButton
        page={paginatable.nextPage}
        onClick={handleChangePage}
        disabled={paginatable.isLastPage}
      >
        Next page
        <ArrowRightIcon className="w-4 scale-x-125 transform" />
      </PaginationButton>
    </HStack>
  );
}
